import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const OvernightFerry = t0 => {
  const $ = _c(14);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M3 19.5V19.5C3.35409 19.2094 3.86419 19.2094 4.21827 19.5L4.88328 20.0459C5.55564 20.5978 6.52711 20.5876 7.18777 20.0217L7.24216 19.9752C7.89386 19.417 8.85817 19.4276 9.49742 20V20C10.1367 20.5724 11.101 20.583 11.7527 20.0248L11.7947 19.9889C12.4591 19.4197 13.4457 19.4253 14.1102 19.9944V19.9944C14.7821 20.5699 15.7863 20.5699 16.4583 19.9944V19.9944C17.1227 19.4253 18.1093 19.4197 18.7738 19.9889V19.9889C19.4495 20.5677 20.4494 20.5566 21.1122 19.9631L21.4772 19.6363C21.8987 19.2588 22.5182 19.2034 23 19.5V19.5" strokeLinecap="round" />;
    t2 = <path d="M3 22.5V22.5C3.35409 22.2094 3.86419 22.2094 4.21827 22.5L4.88328 23.0459C5.55564 23.5978 6.52711 23.5876 7.18777 23.0217L7.24216 22.9752C7.89386 22.417 8.85817 22.4276 9.49742 23V23C10.1367 23.5724 11.101 23.583 11.7527 23.0248L11.7947 22.9889C12.4591 22.4197 13.4457 22.4253 14.1102 22.9944V22.9944C14.7821 23.5699 15.7863 23.5699 16.4583 22.9944V22.9944C17.1227 22.4253 18.1093 22.4197 18.7738 22.9889V22.9889C19.4495 23.5677 20.4494 23.5566 21.1122 22.9631L21.4772 22.6363C21.8987 22.2588 22.5182 22.2034 23 22.5V22.5" strokeLinecap="round" />;
    t3 = <path d="M11 3.18188H11.8591" />;
    t4 = <path d="M11.0361 3.18188H10.177C10.0543 3.18188 9.80886 3.3031 9.80886 3.78795C9.80886 4.27279 9.80886 5.20209 9.80886 5.60613" />;
    t5 = <path d="M20.9831 12.9999L20.0232 16.8574C19.8927 17.3817 19.3688 17.7099 18.8399 17.5987L13.6938 16.5161C13.2329 16.4191 12.9039 16.0143 12.9039 15.544V11.5358C12.9039 10.8873 13.514 10.4077 14.1453 10.56L20.2409 12.0302C20.5486 12.111 21.1278 12.4181 20.9831 12.9999Z" />;
    t6 = <path d="M4.83948 12.9999L5.80424 16.8769C5.93275 17.3933 6.44378 17.721 6.9669 17.6223L12.1082 16.6528C12.5788 16.564 12.9186 16.1547 12.9186 15.6766L12.9186 11.5358C12.9186 10.8873 12.3085 10.4077 11.6772 10.56L5.5816 12.0302C5.27391 12.111 4.6947 12.4181 4.83948 12.9999Z" />;
    t7 = <path d="M4.83948 12.9999L5.80424 16.8769C5.93275 17.3933 6.44378 17.721 6.9669 17.6223L12.1082 16.6528C12.5788 16.564 12.9186 16.1547 12.9186 15.6766L12.9186 11.5358C12.9186 10.8873 12.3085 10.4077 11.6772 10.56L5.5816 12.0302C5.27391 12.111 4.6947 12.4181 4.83948 12.9999Z" />;
    t8 = <path d="M14 5.72729H8.09089H7.35453C7.10907 5.72729 6.61816 5.87275 6.61816 6.45457C6.61816 7.03639 6.61816 10.1717 6.61816 11.6667L12.7423 10.0673C12.9111 10.0232 13.0886 10.0241 13.2571 10.0698L19.1363 11.6667" />;
    t9 = <path d="M15.5 3.5H18.5V4L15.5 8V8.5H18.5" strokeWidth="0.8" />;
    t10 = <path d="M21 3H23V3.4L21 6.6V7H23" strokeWidth="0.8" />;
    $[2] = t1;
    $[3] = t10;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t1 = $[2];
    t10 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== props) {
    t11 = <IconWrapper {...props} variant="outline" viewBox="0 0 25 25">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</IconWrapper>;
    $[12] = props;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};
export { OvernightFerry };